export const API_BASE_URL = 'https://etracking.matarstars.com/api_dev/v1';
export const MAP_API_URL = 'https://etracking.matarstars.com/route/v1';
export const MAP_BASE_URL =
  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
export const EXAMPLE_UPLOAD_MARKER =
  'https://etracking.matarstars.com/tms_file/mau_nhap_excel.xlsx?version=' + Math.floor(Math.random() * 10000);
export const EXAMPLE_UPLOAD_FILE =
  'https://matarminhducvideo15days.s3.ap-southeast-1.amazonaws.com/ke+hoach+1.xlsx';
